<template>
    <div>
        <loading-component :value="loading"></loading-component>
        <v-container>
            <v-layout>
                <v-flex xs4>
                    <v-select
                            v-model="provider"
                            label="Provider"
                            :items="['passengers','captains','numbers']"
                    />
                </v-flex>
                <v-flex xs4>
                    <v-switch v-model="csv_file"
                              :label="csv_file ? 'CSV' : 'Select'"
                    ></v-switch>
                </v-flex>
                <v-flex xs12>
                    <choose-passenger-multi v-if="!csv_file && provider_name === 'passengers'"
                                            :rules="[v => !!v || 'This Field Is Required']"
                                            return-object
                                            v-model="form.ids" label="Choose Passengers"/>
                    <choose-captains-multi v-else-if="!csv_file && provider_name === 'captains'"
                                           :rules="[v => !!v || 'This Field Is Required']"
                                           return-object
                                           v-model="form.ids" label="Choose Captains"/>
                    <template v-else>
                        <v-label>
                            CSV File(each line is an id of a {{provider_name}})
                        </v-label>
                        <input type="file" accept=".csv,.txt" @change="passengersCSVChanges"/>
                    </template>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex offset-xs3 xs12 md6>
                    <v-select
                            v-model="form.broadcast"
                            :items="['SMS', 'Whatsapp', 'Notification']"
                            attach
                            chips
                            label="Broadcast Use"
                            multiple
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout v-if="form.broadcast.includes('Whatsapp')">
                <v-flex offset-xs3 xs 12 md6>
                    <v-select
                            v-model="form.whatsapp_from"
                            :items="api.CONSTANTS.WHATSAPP_NUMBERS"
                            attach
                            chips
                            label="Whatsapp Number"
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 style="text-align:center; font-size: 18pt; font-weight: bold;">
                    Presets
                </v-flex>
            </v-layout>
            <v-layout style="font-weight:bold">
                <v-flex xs3>
                    Preset
                </v-flex>
                <v-flex xs4>
                    Description
                </v-flex>
                <v-flex xs2>
                    Since
                </v-flex>
                <v-flex xs2 offset-xs1>
                    active
                </v-flex>
            </v-layout>
            <v-layout v-for="(presetSettings,preset) in presets" style="align-items: baseline">
                <v-flex xs3>
                    {{preset}}
                </v-flex>
                <v-flex xs4>
                    {{presetSettings.description}}
                </v-flex>
                <v-flex xs2>
                    <choose-date v-model="sinces[preset]"/>
                </v-flex>
                <v-flex xs2 offset-xs1>
                    <v-checkbox color="primary" v-model="activePresets[preset]"/>
                </v-flex>
            </v-layout>
            <v-textarea label="Message" v-model="form.message"></v-textarea>
            <div style="text-align: center">
                <v-btn color="primary" @click="submit" :disabled="loading">Submit</v-btn>
            </div>
        </v-container>
    </div>
</template>

<script>
    import ChoosePassengerMulti from "@/components/wasilni/input/ChoosePassengerMulti";
    import ChooseCaptainsMulti from "@/components/wasilni/input/ChooseCaptainMulti";
    import LoadingComponent from "@/components/LoadingComponent";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";

    export default {
        name: "Broadcast",
        components: {ChooseDate, LoadingComponent, ChooseCaptainsMulti, ChoosePassengerMulti},
        data() {
            return {
                csv_file: false,
                form: {
                    ids: [],
                    broadcast: [],
                    message: '',
                    whatsapp_from: this.api.CONSTANTS.WHATSAPP_NUMBERS[0]
                },
                provider: 'passengers',
                loading: false,
                presets: {},
                activePresets: {},
                sinces: {}
            };
        },
        computed: {
            provider_name() {
                return this.provider;
            },
            map_ids() {
                return this.form.ids.map(item => item.id ? item.id : item);
            }
        },
        watch: {
            provider() {
                this.ids = [];
            }
        },
        mounted() {
            this.loading = true;
            this.axios.get(this.api.ACTIONS.BROADCAST_PRESETS)
                .then(res => {
                    this.presets = res.data.data;
                    this.activePresets = Object.assign(...Object.keys(res.data.data).map(x => ({[x]: false})));
                    this.sinces = Object.assign(...Object.keys(res.data.data).map(x => ({[x]: "2000-01-01"})));
                })
                .finally(() => this.loading = false)
        },
        methods: {
            passengersCSVChanges(e) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    if (files[0].name.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader();
                    fr.readAsText(files[0]);
                    fr.addEventListener('load', () => {
                        this.form.ids = fr.result.split("\n").filter(
                            item => !isNaN(parseInt(item)) && parseInt(item) == item
                        ).map(item => ({
                            id: item,
                            first_name: "id " + item,
                            last_name: ""
                        }));
                    })
                }
            },
            submit() {
                if (!this.form.broadcast.length || (this.form.ids.length === 0 && Object.keys(this.activePresets).length === 0)) {
                    window.getApp.$emit("SHOW_TOAST", 'complete info please', 'red');
                    return;
                }
                this.loading = true;
                this.axios.put('broadcast', {
                    ids: this.map_ids.length === 0 ? null : this.map_ids,
                    provider: this.provider_name,
                    message: this.form.message,
                    broadcast: this.form.broadcast,
                    whatsapp_from: this.form.whatsapp_from,
                    presets: Object.keys(this.activePresets).filter(x => this.activePresets[x]).map(preset => ({
                        type: preset,
                        rules: {
                            since: this.sinces[preset]
                        }
                    }))
                })
                    .then(() => {
                        this.form = {
                            ids: [],
                            broadcast: [],
                            message: '',
                            whatsapp_from: this.api.CONSTANTS.WHATSAPP_NUMBERS[0]
                        };
                        window.getApp.$emit("SHOW_TOAST", 'Broadcasting has been started successfully', 'primary');
                    }).catch(err => {
                    let message = '';
                    try {
                        message = err.response.data.message;
                    } catch (e) {
                        message = 'failed to get captain, please open inspect tool and take a screen shot';
                    }
                    window.getApp.$emit('SHOW_TOAST', message, 'red');
                }).finally(() => this.loading = false);
            }
        }
    }
</script>

<style scoped>

</style>
